import httpClient from '../utils/axios'
import {
  handleServiceResponse,
  handleServiceError,
} from '../utils/serviceResponseHelper'

const getDocumentTemplates = async serviceId => {
  return httpClient
    .get(
      `${window.config.DOCUMENT_API_URL}/v1/documenttemplate/getall?serviceId=${serviceId}`
    )
    .then(
      response => handleServiceResponse(response),
      error => handleServiceError(error)
    )
}
//Doesn't need service ID
const getDocumentTemplate = async (id, serviceId) => {
  return httpClient
    .get(
      `${window.config.DOCUMENT_API_URL}/v1/documenttemplate/get?documentId=${id}&serviceId=${serviceId}`
    )
    .then(
      response => handleServiceResponse(response),
      error => handleServiceError(error)
    )
}

const addDocumentTemplate = async newTemplate => {
  return httpClient
    .post(
      `${window.config.DOCUMENT_API_URL}/v1/documenttemplate/create`,
      newTemplate
    )
    .then(
      response => handleServiceResponse(response),
      error => handleServiceError(error)
    )
}

const updateDocumentTemplate = async updateTemplate => {
  return httpClient
    .put(
      `${window.config.DOCUMENT_API_URL}/v1/documenttemplate/update`,
      updateTemplate
    )
    .then(
      response => handleServiceResponse(response),
      error => handleServiceError(error)
    )
}

export default {
  getDocumentTemplates,
  getDocumentTemplate,
  addDocumentTemplate,
  updateDocumentTemplate,
}
